import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBottle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBottle"><Path d="M13.5 1.5V7.5L17.5 10.5V22.5H6.5V10.5L10.5 7.5V1.5H13.5ZM13.5 1.5H14" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 1.5H10" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBottle;
